import { Dropdown, Pagination, Space } from "antd";
import { AiTwotoneSetting } from "react-icons/ai";
import {
  FaEdit,
  FaEllipsisV,
  FaEye,
  FaEyeSlash,
  FaInfoCircle,
  FaTrashRestoreAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Alert from "../../../../global/alert/Alert";
import {
  formatDate,
  useDelete,
  useStatusChange,
} from "../../../../../utils/CustomFunctions";
import { IoCloseSharp } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import { useState } from "react";

export const Table = ({ articles }) => {
  // for state change
  const { loading, handleStatusChange } = useStatusChange(
    "admin",
    "article_change_status",
    "articles",
    "articles"
  );
  // for soft delete and parmanently delete
  const { isLoading, handleDelete } = useDelete(
    "admin",
    "articles",
    "articles",
    "article_categories"
  );
  const msg = {
    icon: <FaInfoCircle className="me-3" />,
    type: "alert-info",
    text: "No help center articles found",
  };

  // for pagination purposes
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const indexOfLastData = currentPage * itemsPerPage;
  const indexOfFirstData = indexOfLastData - itemsPerPage;
  const currentData = articles?.slice(indexOfFirstData, indexOfLastData);

  return (
    <>
      <div className="row organizer-event">
        <div className="col-12">
          {articles?.length > 0 ? (
            <div className="card">
              <div className="table-responsive">
                <table className="table table-hover table-vcenter">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Category</th>
                      <th>Last updated</th>
                      <th>Status</th>
                      <th className="text-center">
                        <AiTwotoneSetting />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.map((article, i) => {
                      const items = [
                        {
                          label: (
                            <Link
                              to={`${article.slug}/edit`}
                              className="d-flex align-items-center"
                            >
                              <FaEdit className="me-1" />
                              Edit
                            </Link>
                          ),
                          key: "0",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) => handleStatusChange(e, article.id)}
                            >
                              {article.status === "visible" ? (
                                <>
                                  <FaEyeSlash className="me-1" />
                                  Hide
                                </>
                              ) : (
                                <>
                                  <FaEye className="me-1" /> Show
                                </>
                              )}
                            </Link>
                          ),
                          key: "1",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(
                                  e,
                                  article.id,
                                  "article_delete",
                                  ""
                                )
                              }
                            >
                              {article?.deleted_at !== null ? (
                                <>
                                  <FaTrashRestoreAlt className="me-1" /> Restore
                                </>
                              ) : (
                                <>
                                  <IoCloseSharp className="me-1" />
                                  Delete
                                </>
                              )}
                            </Link>
                          ),
                          key: "2",
                        },
                        article.deleted_at && {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(
                                  e,
                                  article.id,
                                  "article_delete_permanent",
                                  "delete_permanent"
                                )
                              }
                            >
                              <MdDelete className="me-1" />
                              Delete permanently
                            </Link>
                          ),
                          key: "3",
                        },
                      ];
                      return (
                        <tr key={i}>
                          <td>
                            <Link
                              to={`/en/help-center/article/${article.slug}`}
                            >
                              {article.name}
                            </Link>
                          </td>
                          <td className="text-capitalize">
                            {article.article_category.name}
                          </td>
                          <td>
                            {formatDate(new Date(article?.updated_at)).fullDate}{" "}
                          </td>
                          <td className="">
                            {article.status === "visible" ? (
                              <span className="badge badge-success d-inline-flex align-items-center">
                                <FaEye className="me-1" /> Visible
                              </span>
                            ) : (
                              <span className="badge badge-danger d-inline-flex align-items-center">
                                <FaEyeSlash className="me-1" /> Hidden
                              </span>
                            )}
                            {article?.deleted_at && (
                              <>
                                <br />
                                <br />
                                <span className="badge badge-danger d-inline-flex align-items-center">
                                  <IoCloseSharp className="me-1" />
                                  Deleted
                                </span>
                              </>
                            )}
                          </td>
                          <td className="text-center">
                            <Dropdown
                              menu={{
                                items,
                              }}
                              trigger={["click"]}
                            >
                              <a onClick={(e) => e.preventDefault()}>
                                <Space className="justify-content-center">
                                  <FaEllipsisV />
                                </Space>
                              </a>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <Alert {...msg} />
          )}
        </div>
      </div>

      {articles?.length > 10 && (
        <Pagination
          current={currentPage}
          total={articles.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
        />
      )}
    </>
  );
};
